import styled from 'styled-components';
import { JoykitColor } from '@components/themes';
import { Box } from '@components/Box';
import { themeColor } from '@utils/styledTheme.util';

interface ImgContainerProps
  extends Readonly<{
    src: string;
    gradient?: string;
    height?: string;
    backgroundHeight?: string;
    backgroundColor?: JoykitColor;
    backgroundPosition?: string;
  }> {}

interface ImgWrapperProps
  extends Readonly<{
    height?: string;
    textCentered?: boolean;
  }> {}

export const Wrapper = styled(Box)<ImgWrapperProps>`
  position: relative;
  height: ${({ height }) => (height ? height : '1072px')};
  width: 100%;
  overflow: hidden;

  @media (min-width: 768px) and (max-width: 1024px) {
    height: 1350px;
  }

  ${({ textCentered }) =>
    textCentered &&
    `
      display: flex;
      align-items: center;
      justify-content: center;
  `}
`;

export const ImgContainer = styled.div<ImgContainerProps>`
  position: absolute;
  top: 0;
  left: 0;
  height: ${({ backgroundHeight }) => (backgroundHeight ? backgroundHeight : '100%')};
  width: 100%;
  z-index: -1;
  background: ${({ gradient, src }) => `${gradient ? gradient + ', ' : ''}url(${src})  no-repeat center/cover`};
  background-color: ${({ backgroundColor }) => (backgroundColor ? themeColor(backgroundColor) : 'transparent')};
  background-position: ${({ backgroundPosition }) => (backgroundPosition ? backgroundPosition : null)};
`;

export const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
